import { Globe } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useConfig } from "./ConfiguracoesLayout";
import ConfigSection, { inputClass } from "./ConfigSection";

const RedesSociais = () => {
  const { form, update } = useConfig();

  return (
    <ConfigSection title="Redes Sociais" icon={Globe}>
      <div className="grid grid-cols-2 gap-4">
        <div className="space-y-2">
          <Label>Instagram</Label>
          <Input value={form.social_instagram} onChange={(e) => update("social_instagram", e.target.value)} className={inputClass} placeholder="@seurestaurante" />
        </div>
        <div className="space-y-2">
          <Label>Facebook</Label>
          <Input value={form.social_facebook} onChange={(e) => update("social_facebook", e.target.value)} className={inputClass} placeholder="facebook.com/seurestaurante" />
        </div>
        <div className="space-y-2">
          <Label>TikTok</Label>
          <Input value={form.social_tiktok} onChange={(e) => update("social_tiktok", e.target.value)} className={inputClass} placeholder="@seurestaurante" />
        </div>
        <div className="space-y-2">
          <Label>Website</Label>
          <Input value={form.social_website} onChange={(e) => update("social_website", e.target.value)} className={inputClass} placeholder="https://seusite.com" />
        </div>
      </div>
    </ConfigSection>
  );
};

export default RedesSociais;
